export const Hr = () => {
    return <div className="hr"></div>
}
